<template>
  <div class="schedule-wrapper">
    <swiper
      class="swiper"
      :options="swiperOption"
    >
      <swiper-slide>
        <div class="crm-tab-slide">
          <base-tabs
            v-model="activeTab"
            class="date-tabs"
            :items="dateTabs.slice(0, 7)"
            :disabled="isScheduleLoading"
          />
        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="crm-tab-slide">
          <base-tabs
            v-model="activeTab"
            class="date-tabs"
            :items="dateTabs.slice(7, 15)"
            :disabled="isScheduleLoading"
          />
        </div>
      </swiper-slide>
      <div
        slot="button-prev"
        class="swiper-button-prev"
      >
        <b-icon icon="caret-left-fill" />
      </div>
      <div
        slot="button-next"
        class="swiper-button-next"
      >
        <b-icon icon="caret-right-fill" />
      </div>
    </swiper>

    <p class="current-date-title">
      {{ currentDateTitle }}
    </p>

    <slot />
  </div>
</template>

<script>
import 'swiper/css/swiper.css';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';

import {
  addDays, format, parseISO,
} from 'date-fns';
import { ru } from 'date-fns/locale';

import { BaseTabs } from '@/components/base';

export default {
  name: 'ScheduleWrapper',
  components: {
    Swiper,
    SwiperSlide,
    BaseTabs,
  },
  directives: {
    swiper: directive,
  },
  props: {
    doctorId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  computed: {
    activeTab: {
      get() {
        return this.$store.state.Schedule.selectedDate;
      },
      set(newValue) {
        this.$store.commit(this.$types.SCHEDULE_DATE_SET, newValue);
      },
    },
    isScheduleLoading() {
      return this.$store.state.Schedule.isScheduleLoading;
    },
    dateTabs() {
      const dateTabs = [];

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < 15; i++) {
        const date = addDays(new Date(), i);

        const dateTab = {
          value: format(date, 'yyyy-MM-dd'),
          description: format(date, 'EEEEEE', { locale: ru }),
          title: format(date, 'dd'),
        };

        dateTabs.push(dateTab);
      }

      return dateTabs;
    },
    currentDateTitle() {
      const date = parseISO(this.activeTab);

      return format(date, 'EEEE, d MMMM y', { locale: ru });
    },
  },
  watch: {
    async activeTab(newVal) {
      try {
        await this.$store.dispatch(this.$types.SCHEDULE_FETCH, {
          id: this.doctorId,
          date: newVal,
        });
      } catch (e) {
        console.warn(e);
      }
    },
    doctorId: {
      async handler(newVal) {
        this.activeTab = this.dateTabs[0].value;
        if (newVal) {
          try {
            await this.$store.dispatch(this.$types.SCHEDULE_FETCH, {
              id: newVal,
              date: this.activeTab,
            });
          } catch (e) {
            console.warn(e);
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule-wrapper {
  width: 100%;
}
.crm-tab-slide {
  width: calc(100% - 80px);
}
::v-deep.swiper {
  margin-bottom: 30px;

  .swiper-slide {
    display: flex;
    justify-content: center;
  }

  .swiper-button-prev {
    left: 0;

    &::after {
      display: none;
    }
  }

  .swiper-button-next {
    right: 0;

    &::after {
      display: none;
    }
  }
}
.current-date-title {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 20px;
  color: $blue;
  text-align: center;

  &::first-letter {
    text-transform: uppercase;
  }
}
::v-deep.date-tabs {
  justify-content: space-between;

  &.disabled {
    opacity: 0.4;
  }

  .crm-tab {
    border-radius: 50%;
    background-color: $blue-light;
    width: 50px;
    height: 50px;
    padding: 0;
    border: none;
    color: $blue-dark;

    &.active {
      color: $white;
      background-color: $blue-dark;
    }
  }
}
</style>
